import React from "react";
//import { Tab, Tabs } from "./common/tab/CommanTab";
import { ReactComponent as PlusIcon } from "../resources/images/icons/plus-icon.svg";
import CustomTabs from "./common/CustomTabs";

interface Props {
  active: string;
  setActive: Function;
  jobStatusCount?: {
    active?: number;
    drafts?: number;
    expired?: number;
    scheduled?: number;
    inbound?:number;
  };
  showInboundTab?:boolean;
}

const MainTabSection = ({ active, setActive, jobStatusCount,showInboundTab }: Props) => {
  const {
    active: activeCount,
    drafts,
    expired,
    scheduled,
    inbound
  } = jobStatusCount || {};

  const tabData = [
    { label: "Active", count: activeCount || 0, action: "active" },
    // { label:"Inbound_Jobs", count: inbound || 0, action:"inbound" },
    ...(showInboundTab 
      ? [{ label: "Inbound_Jobs", count: inbound || 0, action: "inbound" }] 
      : []),
    { label: "Drafts", count: drafts || 0, action: "Drafts" },
    { label: "Scheduled", count: scheduled || 0, action: "Scheduled" },
    { label: "Expired", count: expired || 0, action: "Expired" },
  ];
  return (
    <div className="mjp_section-wrapper">
      <div className="mjp_main-tab_title">
        <div className="mjp_main-tab_label">Manage jobs </div>
        <span
          className="foundit-button primaryButton xls"
          style={{width:"120px"}}
          role="button"
          onClick={() =>
            window.open(
              `${window.location.origin}/edge/jobposting/new-job-posting`,
              "_blank"
            )
          }
        >
          <PlusIcon style={{marginRight:"4px"}}/>
          Post a Job
        </span>
      </div>

      <div className="mjp_main-tab_box">
        <CustomTabs
          tabData={tabData}
          activeTab={active}
          setActiveTab={setActive}
        />
      </div>
    </div>
  );
};

export default MainTabSection;
